import { createStore, createStateHook, createActionsHook } from 'react-sweet-state';
import { actions, type Actions } from './actions';
import type { State } from './types';

const initialState: State = {
	showViewSettingsNudge: false,
};

const Store = createStore<State, Actions>({
	initialState,
	actions,
	name: 'issue-links-nudge-store',
});

export const useShowViewSettingsNudge = createStateHook(Store, {
	selector: (state) => state.showViewSettingsNudge,
});

export const useShowViewSettingsNudgeActions = createActionsHook(Store);
